export default {
  "女模": "Girls",
  "男模": "Boys",
  "加载中": "Loading",
    "已有账号？": "Have an account?",
    "去登录": "Login",
    "首次登录，请选择语言": "First login, please select language",
    "立即切换": "Switch Now",
    "投注": "Bet",
    "请先绑定银行卡": "Bind bank card first",
    "历史": "History",
    "绑定上限，请联系客服!": "Limit reached, contact support!",
    "已达绑定上限": "Binding Limit Reached",
    "任务详情": "Task Details",
    "投票详情": "Voting Details",
    "获得金额": "Amount Received",
    "待结算": "Pending Settlement",
    "再来一次": "Try Again",
    "时间": "Time",
    "备注": "Remarks",

    accountDetailTab: {
        "充值": 'Top-up',
        "提现": 'Withdrawal',
        "投票": 'Voting details',
    },
    "选择{name}": "Select {name}",
    "个人简介": "Personal Profile",
    "投票金额": "Vote Amount",
    "投票记录": "Voting History",
    "投票方向": "Voting Direction",
    "下注金额": "Bet Amount",
    "投票": "Vote",
    "确认投票": "Confirm Vote",
    "银行账户号码": "Bank Account Number",
    "提现到": "Withdraw To",
    "去绑定": "Bind Now",
    "信誉分": "Credit Score",
    "立即预约": "Book Now",
    "取款方式": "Withdrawal Method",
    "住所": "Residence",
    "照片": "Photo",
    "胸围": "Bust",
    "约炮推荐": "Hookup Recommendation",
    "高端专区": "Premium Section",
    "暂无信息": "No Information",
    "观影券": "Movie Voucher",
    "观影券不足": "Insufficient Movie Vouchers",
    "详情信息": "Detailed Information",
    "银行卡": "Bank Card",
    "x次认证": "{num} Times Verified",
    "请输入您的收款卡信": "Please Enter Your Payment Card Info",
    "绑定银行卡": "Withdrawal",
    "绑定USDT地址": "Link USDT Address",
    "请选择{name}": "Please Select {name}",
    "请输入{name}": "Please Enter {name}",
    "银行地址": "Bank Address",
    "银行账户": "Bank Account",
    "ABA/路由代码": "ABA/Routing Code",
    "SWIFT代码": "SWIFT Code",
    "姓名": "Name",
    "虚拟币": "Cryptocurrency",
    "币种": "Currency",
    "地址": "Address",
    "确认绑定": "Confirm Binding",
    "银行列表": "Bank List",
    "暂无数据": "No Data",
    "充值": "Top-up",
    "旧密码": "Old Pwd",
    "新密码": "New Pwd",
    "请输入您的旧密码": "Enter Old Pwd",
    "请输入您的新密码": "Enter New Pwd",
    "请再次输入您的新密码": "Re-enter New Pwd",
    "修改登录密码": "Change Pwd",
    "收款卡信息": "Card Info",
    "投票结果": "Results",

    tabbar: {
        "首页": "Home",
        "预约": "Verification",
        "地区选择": "Date",
        "视频": "Video",
        "我的": "My"
    },
    "高端": "Premium",
    "认证": "Verified",
    "视频认证": "Video Verification",
    "收费区间": "Service Rating",
    "服务评分": "Service Rating",
    "身高": "Height",
    "胸圍": "Bust",
    "服務城市": "Service City",
    "全國空降": "Nationwide",
    "是": "Yes",
    "否": "No",
    "我要约她": "View Her",
    "我要约他": "View Him",
    "城市大全": "Cities",
    "流程价格": "Process Price",
    "刷新成功": "Refresh Success",
    "预约大厅": "Booking Hall",
    "全部": "All",
    "查看更多": "More",
    "推荐任务": "Recommended Tasks",
    "人气排行": "Popularity",
    "热门推荐": "Hot Picks",
    "获取中": "Loading",
    "语言": "Language",
    "登录": "Login",
    "忘记密码": "Forgot Password",
    "没有账户？马上注册": "No Account? Register Now",
    "请输入用户名": "Enter Username",
    "请输入密码": "Enter Password",
    "注册": "Sign Up",
    "我已经知晓并同意'开户协议'各项条约": "I Agree to the 'Account Agreement'",
    "请输入邀请码": "Enter Invite Code",
    "请输入用户名({min}-{max}个英文字母或数字)": "Enter Username ({min}-{max} Letters/Numbers)",
    "请输入登录密码({min}-{max}个英文字母或数字)": "Enter Password ({min}-{max} Letters/Numbers)",
    "请勾选下方开户协议": "Please Agree to the Account Terms",
    "可用余额": "Available Balance",
    "元": "Yuan",
    "提交": "Submit",
    "当前选号": "Current selection",
    "每注金额": "Amount per Bet",
    "请输入金额": "Enter Amount",
    "总共": "Total",
    "注": "Bets",
    "合计": "Total",
    "任务单": "Task List",
    "1注X{money}元={money}元": "1 Bet X {money} = {money}",
    "清空订单": "Clear Order",
    "确认提交": "Confirm",
    "期号": "Issue No.",
    "第{x}期": "Issue {x}",
    "数据": "Data",
    "双": "Even",
    "单": "Odd",
    "未选择": "Not Selected",
    "金额错误": "Invalid Amount",
    "请选号": "Pick Numbers",
    "请填写金额": "Enter Amount",
    "余额不足，请联系客服充值！": "Insufficient Balance, Contact Support!",
    "未选中": "Not Selected",
    "请联系管理员领取该任务": "Contact Admin for Task",
    "开奖成功，期号：": "Draw Success, No.:",
    "大": "Big",
    "小": "Small",
    "填写收款卡": "Fill Payment Card",
    "请输入您的收款卡信息": "Enter Card Info",
    "银行卡号": "Card Number",
    "请输入真实银行卡号": "Enter Valid Card Number",
    "银行名称": "Bank Name",
    "请选择银行": "Select Bank",
    "尊敬的用户,为了保障您的资金安全,请您绑定您的真实姓名和设置取款密码,如果姓名与开户名不一致,将无法取款": "Bind Real Name & Withdrawal Password to Ensure Security",
    "确认绑卡": "Bind Card",
    "请输入银行卡号": "Enter Card Number",
    "任务记录": "Task History",
    "任务记录Title": "Voting history record",
    "数据为空": "No Data",
    "下单时间": "Voting Time",
    "结算时间": "Settlement Time",
    "提现": "Withdraw",
    "我的钱包": "My Wallet",
    "详情": "Details",
    "余额": "Balance",
    "个人报表": "Personal Report",
    "账户明细": "Account Details",
    "个人中心": "Profile",
    "信息公告": "Announcements",
    "在线客服": "Support",
    "请完成任务单后进入": "Complete Task First",
    "请联系客服充值": "Contact Support for Recharge",
    "请设置收款卡": "Set Payment Card",
    "功能已禁用": "Feature Disabled",
    "账号下线": "Account Offline",
    "登录/注册": "Login/Sign Up",
    "登录可享受更多服务": "Login for More Services",
    "基本信息": "Basic Info",
    "头像": "Avatar",
    "选择头像": "Choose Avatar",
    "确定": "Confirm",
    "取消": "Cancel",
    "真实姓名": "Real Name",
    "未设置": "Not Set",
    "性别": "Gender",
    "绑定信息": "Bound Info",
    "已绑定": "Bound",
    "无": "None",
    "男": "Male",
    "女": "Female",
    "未知": "Unknown",
    "系统公告": "System Notice",
    "盈利金额": "Profit",
    "盈利计算公式 : 中奖金额 - 任务金额": "Profit = Win Amount - Voting amount",
    "任务金额": "Task Amount",
    "充值金额": "Recharge Amount",
    "提现金额": "Withdraw Amount",
    "中奖金额": "Win Amount",
    "客服": "Support",
    "蜜獾娱乐": "Honey Badger Entertainment",
    "联系": "Contact",
    "全天7 * 24小时竭诚为您服务": "24/7 Support",
    "添加收款卡": "Add Card",
    "提示:请绑定大型商业银行,如需修改,请您联系在线客服": "Tip: Bind Major Banks. For Changes, Contact Support.",
    "修改真实姓名": "Edit Name",
    "保存": "Save",
    "请输入真实姓名": "Enter Real Name",
    "为了您账户安全,真实姓名需要与绑定银行卡姓名一致": "Real Name Must Match Card Name",
    "请勿重复设置": "No Repeated Setting",
    "请输入姓名": "Enter Name",
    "请输入资金密码": "Enter Fund Password",
    "设置资金密码": "Set Fund Password",
    "请再次输入资金密码": "Re-enter Fund Password",
    "请填写完整": "Complete All Fields",
    "两次密码不一致": "Passwords Don’t Match",
    "性别修改": "Edit Gender",
    "设置": "Set",
    "基本信息设置": "Basic Info Setup",
    "登录密码": "Login Password",
    "资金密码": "Fund Password",
    "退出登录": "Logout",
    "已设置": "Set",
    "提现密码已设置，需要修改请联系客服": "Withdraw Password Set, Contact Support for Changes",
    "提现中心": "Withdraw Center",
    "提现记录": "Withdraw History",
    "1.单笔限额：最低{min}元，最高{max}元": "1. Per Limit: Min {min}, Max {max}",
    "2.提现次数：一天最高提现{num}次": "2. Max {num} Withdraws per Day",
    "3.到账时间": "3. Arrive - 15 minutes, maximum 2 hours",
    "限额说明": "Limit Info",
    "马上提现": "Withdraw Now",
    "请填写正确的金额": "Enter Valid Amount",
    "金额": "Amount",
    "说明": "Note",
    "提交时间": "Submission Time",
    "审核时间": "Review Time",
    "视频影院": "Video Cinema",
    "没有更多了": "No More",
    "播放": "Play",
    "x播放": "{count} Play",
    "首页": "Home",
    "选妃": "Select",
    "选妃列表": "Selection List",
    "选妃详情": "Selection Details",
    "语言选择": "Language Choice",
    "我的": "My",
    "视频": "Video",
    "游戏": "Game",
    "修改性别": "Edit Gender",
    "支付密码管理": "Payment Password",
    "登录密码管理": "Login Password",
    "详情页面": "Details Page",
    "视频播放": "Video Play",

    "本期":"Current period",
    "剩余时间":"Time remaining",
    "立即投票":"Vote Now",
    "提前预订卡进度":"Advance booking card progress",

    "预订状态":"Booking Status",
}
   